import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { RxComponent } from 'app/core/components/common/rx.component';
import { RequestService } from 'app/core/services/request.service';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { AmberApi } from 'app/core/models/api-helpers';

@Component({
    selector: 'itpx-preview-certificate',
    templateUrl: './preview-certificate.component.html',
    styleUrls: ['./preview-certificate.component.css']
})
export class PreviewCertificateComponent extends RxComponent {

    @Input()
    private data: PreviewCertificateModel;

    private downloadClicked = new Subject();

    constructor(
        private requestService: RequestService,
        private profileService: ProfileService
    ) {
        super();
    }

    ngOnInit() {

        let certificateData = this.profileService.getProfile()
            .extract(AmberApi.Data)
            .map(profile => this.getCertificateData(profile))
            .share();

        certificateData
            .flatMap(data => this.data.previewFn(data).neverError())
            .extract(AmberApi.Data)
            .bindToLifecycle(this)
            .subscribe(html => {
                let iFrameDocument = document.querySelector('#certificate-holder')['contentWindow'].document;
                iFrameDocument.open('text/html', 'replace');
                iFrameDocument.write(html);
                iFrameDocument.close();
            });

        this.downloadClicked
            .withLatestFrom(certificateData, (_, certData) => certData)
            .flatMap(certData => this.data.downloadFn(certData).neverError())
            .extract(AmberApi.Data)
            .flatMap(fileUrl => this.requestService.get(fileUrl, { attachment: true }, 'blob').neverError())
            .bindToLifecycle(this)
            .subscribe();
    }

    private getCertificateData(profile: any) {
        let [firstName, lastName] = profile.name ? profile.name.split(' ') : ['John', 'Smith'];
        let defaultData = {
            certificateDTO: { template: this.data.certificateTemplate },
            userDTO: {
                firstName: firstName || '',
                lastName: lastName || ''
            }
        };

        let passedData = this.data.certData || {};
        // Merge passed with default data -> order matters!
        return Object.assign({}, defaultData, passedData);
    }

    private downloadClick() {
        this.downloadClicked.next();
    }
}

export class PreviewCertificateModel {

    previewFn: (data) => Observable<any>;
    downloadFn: (data) => Observable<any>;
    certData?: any;
    certificateTemplate?: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/preview-certificate/preview-certificate.component.ts